import { render, staticRenderFns } from "./EventStatusChipPostponed.vue?vue&type=template&id=7db07760&scoped=true&"
import script from "./EventStatusChipPostponed.vue?vue&type=script&lang=js&"
export * from "./EventStatusChipPostponed.vue?vue&type=script&lang=js&"
import style0 from "./EventStatusChipPostponed.vue?vue&type=style&index=0&id=7db07760&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db07760",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
